import type { FailureRow } from '../../api';
import { Panel } from '../../components/kit';

const FAILURE_LABEL: Record<string, string> = {
  config: 'Not configured',
  cancelled: 'Stopped by a human',
  timeout: 'Timed out',
  'agent-error': 'Agent errored',
  blocked: 'Agent was blocked',
  'no-commits': 'Nothing committed',
  uncommitted: 'Left changes uncommitted',
  'worker-lost': 'Worker disappeared',
  infrastructure: 'Infrastructure',
};

/** Why runs failed, countable at last. Runs that failed before this existed
 *  carry no kind, and are shown as such rather than guessed at. */
export function Failures({ failures }: { failures?: FailureRow[] }) {
  if (!failures || failures.length === 0) return null;
  const total = failures.reduce((sum, row) => sum + row.runs, 0);
  return (
    <Panel description={`Why the ${total} failed run${total === 1 ? '' : 's'} in this window failed.`}>
      <div className="flex flex-col gap-2">
        {failures.map((row) => (
          <div key={row.failure ?? 'unknown'} className="flex items-center gap-3">
            <span className="w-52 shrink-0 text-[12.5px]">
              {row.failure ? (FAILURE_LABEL[row.failure] ?? row.failure) : 'Recorded before this was tracked'}
            </span>
            <span
              className="h-2 rounded-full bg-bad/70"
              style={{ width: `${Math.max(4, Math.round((row.runs / total) * 60))}%` }}
              aria-hidden
            />
            <span className="data text-ink-2">{row.runs}</span>
          </div>
        ))}
      </div>
    </Panel>
  );
}

/** A live count riding in a tab label, so a switched-away surface still reports. */
